/* Place to put url constants for API */

export const PATH = {
  applicants: 'v1/applicants',
  applicantsLogin: 'v1/applicants/login',
  applicantsNewPassword: 'v1/applicants/resetpassword',
  applicantsRegister: 'v1/applicants/register',
  applicantsResetPassword: 'v1/applicants/sendresetpasswordemail',
  appliedJobsList: 'v1/savedapplications',
  churchillApplyRedirect: 'apply/',
  churchillJobRedirect: 'job/',
  companyProfiles: 'v1/company_profiles/',
  credentialingJobTypeAndState:
    'v1/credentialing/latest-credential-job-type-state/',
  credentialingStateFullName: 'v1/credentialing/availability/',
  easyApply: 'v1/application/easy-apply/',
  industries: 'search/industries/',
  ipInfo: 'v1/get-geolocation?ip=',
  jobCities: 'search/cities/',
  jobDescription: 'v1/jobs/',
  jobTranslate: 'v1/translate/',
  licenseVerification: 'v1/credentialing/validate/',
  numberOfQuestions: 'v1/jobs/get-num-questions/',
  processedApplications: 'v1/processedapplications',
  questionTranslate: 'v1/translate/question_template/',
  quickRegister: 'v1/applicants/quick-register',
  resumeParsing: 'v1/resume-parsing/file',
  searchJobs: 'search/jobs/',
  shortenLink: 'v1/links/shorten?longUrl=',
  updateApplicantWotcCheckStatus:
    'v1/wotc_check/update_applicant_wotc_check_status/',
  uploadLicenseFile: 'v1/credentialing/license/upload/',
};

export const apiUrl = async (activeEnvironment, domain, path) => {
  console.log('API CALLED FOR', domain);

  let baseDomainUrl = '';
  let integrationsDomainUrl = '';
  switch (activeEnvironment) {
    case 'production':
      baseDomainUrl = 'api.apploi.com';
      integrationsDomainUrl = 'ats-integrations.apploi.com';
      break;
    case 'staging':
      baseDomainUrl = `api-${activeEnvironment}.apploi.com`;
      integrationsDomainUrl = 'ats-integrations-staging.apploi.com';
      break;
    default:
      baseDomainUrl = `api-${activeEnvironment}.apploi.com`;
      integrationsDomainUrl = `ats-${activeEnvironment}.apploi.com`;
  }

  const isBrowser = typeof window !== 'undefined';
  const BASE_URL =
    (isBrowser && window.baseURL) ||
    process.env.BASE_URL ||
    `https://${baseDomainUrl}/`;
  const INTEGRATIONS_URL =
    (isBrowser && window.integrationsURL) ||
    process.env.integrationsURL ||
    `https://${integrationsDomainUrl}/`;

  const DOMAIN_GLOBAL = {
    baseUrl: BASE_URL,
    integrations: INTEGRATIONS_URL,
    churchillRedirect:
      isBrowser && window.location ? `${window.location.origin}/` : '',
  };

  const url = `${DOMAIN_GLOBAL[domain]}${path ? PATH[path] : ''}`;

  return url;
};
